<div class="toolbar-container pb-3">
  <div class="rental-title">
    <ng-container *ngIf="rental">
      <app-rental-image [rental]="rental" [size]="40"></app-rental-image>
      {{ rental.name }}
    </ng-container>
    <app-page-help videoId="nA4jnx2LO9I" class="ml-2"></app-page-help>
  </div>

  <div>
    <button type="button" [disabled]="1 | isReadonlyRole" class="btn btn-success text-uppercase" (click)="onAdd()">
      <span class="fas fa-compress-alt"></span> Add Mapping
    </button>

    <button
      [disabled]="dataSource?.data?.length === 0 || (1 | isReadonlyRole)"
      type="button"
      class="btn btn-info text-uppercase"
      (click)="onPushAllRates()"
    >
      <span class="fas fa-arrow-up"></span> Push All Rates
    </button>
  </div>
</div>
<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table #table matSort matSortActive="channelName" matSortDirection="asc" [dataSource]="dataSource">
      <ng-container matColumnDef="channelName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Channel Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <i
            *ngIf="!rateMapHasConnection(element)"
            matTooltip="Rental is not linked to a channel, rate push will fail."
            matTooltipClass="text-center"
            matTooltipPosition="above"
            class="fal fa-exclamation-triangle"
          ></i>
          {{ element.channelName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="propertyId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Property ID</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.propertyId }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="roomId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Room ID</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.roomId }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rateName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Channel Category</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.rateName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Tokeet Category</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.category }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="created">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Date Mapped</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span [matTooltip]="element.created | epoch" matTooltipPosition="above" matTooltipClass="text-center">
            {{ element.created | epoch : 'DD - MMM - YYYY' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="autoSync">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <span
            matTooltip="Automatic synchronization applies to Dynamic Rates only. When enabled Tokeet will automatically update your channel rates as your availability changes."
            matTooltipPosition="below"
            matTooltipClass="text-center"
          >
            Auto Sync <i class="fas fa-info-circle"></i>
          </span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-slide-toggle
            #slideToggle
            [disabled]="updatingSync[element.key] || (1 | isReadonlyRole)"
            [checked]="!!element.autoSync"
            (toggleChange)="onChangeSync(element, slideToggle)"
            [matTooltip]="
              element.autoSync
                ? 'Synchronization is enabled for this rate mapping.'
                : 'Synchronization is disabled for rate mapping.'
            "
            matTooltipPosition="left"
            matTooltipClass="text-center"
          >
          </mat-slide-toggle>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef>Edit</mat-header-cell>

        <mat-cell *matCellDef="let element">
          <div dropdown placement="bottom right" container="body" [isDisabled]="1 | isReadonlyRole">
            <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
              <a class="btn-ellips">
                <i class="fas fa-ellipsis-v"></i>
              </a>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
              <li>
                <button (click)="onPushRate(element)" type="button"><i class="fas fa-arrow-up"></i> Push Rate</button>
              </li>
              <li>
                <button (click)="onDelete(element)" type="button"><i class="fal fa-trash-alt"></i>Delete</button>
              </li>
            </ul>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.row-danger]="!rateMapHasConnection(row)"
      ></mat-row>
    </mat-table>

    <mat-paginator
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="isEmptyTable$ | async"
      [pageSize]="20"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator>

    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType" class="bg-white"></app-empty-table>
  </table>
</div>
